import React, { FC, memo, useEffect, useState } from "react";
import classes from "./HierarchyCheckboxForfield.module.scss";
import {
  Box,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { fields } from "../../../../commons/fields";
import { useRecoilState } from "recoil";
import { userState } from "../../../../states/userState";
import { User } from "../../../types/user";
import { setUserToLocalStorage } from "../../../../functions/localStorageManager";
import {
  backGroundColorCode,
  foreColor,
  foreColorChecked,
  foreColorCode,
  foreColorCodeLite,
} from "../../../../commons/colors";
const SelectBoxForField: FC = memo(() => {
  const [user, setUser] = useRecoilState(userState);
  const [checkedArray, setCheckedArray] = useState<Array<boolean>>([]);
  //   const [valueArray, setValueArray] = useState<Array<number>>([]);
  //checkboxの初期値設定
  useEffect(() => {
    // 全工場が選択されている場合
    if (user.filters.field.includes(0)) {
      setCheckedArray(new Array(fields.length - 1).fill(true));
    } else {
      // 特定の工場が選択されている場合
      const newCheckedArray = fields
        .slice(1)
        .map((field) => user.filters.field.includes(field.id));
      // console.log("newCheckedArray:", newCheckedArray);
      setCheckedArray(newCheckedArray);
    }
  }, [user.filters.field]);
  const [displayString, setDisplayString] = useState<String[]>(["全分野"]);
  useEffect(() => {
    // user.filters.fieldが空、または全工場(0)を含む場合は、"全工場"と表示
    if (user.filters.field.length === 0 || user.filters.field.includes(0)) {
      setDisplayString(["全分野"]);
    } else {
      // user.filters.fieldに含まれる各idに対応するfieldsのshortNameを結合
      const names = user.filters.field
        .map((id: number) => fields.find((field) => field.id === id)?.name)
        .filter((name: string) => name !== undefined); // undefinedを除外
      // .join(" "); // 半角スペースで結合
      // console.log("names:", names);
      setDisplayString(names);
    }
  }, [user.filters.field]);
  const children = (
    <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
      {fields.slice(1).map((field, index) => (
        <FormControlLabel
          key={field.id}
          sx={{
            height: "38px",
            marginLeft: "-14px",
            fontSize: "0.8rem",
            color: foreColorCode(user?.mode ?? "dark"),
            backgroundColor: backGroundColorCode(user?.mode ?? "dark"),
            // 選択された状態のスタイル
            "&.Mui-selected": {
              backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択時の背景色を変更
              color: foreColorCodeLite(user?.mode ?? "dark"), // 選択時の文字色を変更
            },

            // ホバー状態のスタイルも定義できます
            "&:hover": {
              backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // ホバー時の背景色を変更
              color: foreColorCodeLite(user?.mode ?? "dark"), // ホバー時の文字色を変更
            },
            // 選択されていてさらにホバーされた状態のスタイル
            "&.Mui-selected:hover": {
              backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択 + ホバー時の背景色
              color: foreColorCodeLite(user?.mode ?? "dark"), // 選択 + ホバー時の文字色
            },
          }}
          //   label={field.name}
          //   sx={{ color: "#0adcc0" }}
          label={
            <MenuItem
              sx={{
                ...foreColorChecked(user?.mode ?? "dark", checkedArray[index]),
                fontSize: "0.8rem",
                "&:hover": {
                  backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // ホバー時の背景色を変更
                  color: foreColorCodeLite(user?.mode ?? "dark"), // ホバー時の文字色を変更
                },
                p: 0,
                m: 0,
              }}
            >
              {field.name}
            </MenuItem>
          }
          control={
            <Checkbox
              value={field.id}
              checked={checkedArray[index]}
              onChange={(e) => handleChangeChild(e, index)}
              sx={{
                "& .MuiSvgIcon-root": foreColor(user?.mode ?? "dark"),
                "&.Mui-checked": foreColor(user?.mode ?? "dark"),
                height: "38px",
              }}
            />
          }
        />
      ))}
    </Box>
  );

  //Allがチェックされているか、一部がチェックされているか、全くチェックされていないかを判定
  const allChecked = checkedArray.every(Boolean);
  const indeterminate = checkedArray.some(Boolean) && !allChecked;
  //チェックボックス配列状態監視
  useEffect(() => {}, [checkedArray]);
  //工場番号デバッグ用
  // useEffect(() => {
  //   console.log("user.filters.field:", user.filters.field);
  // }, [user.filters.field]);
  //全工場選択
  const handleChangeAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    // 全てがチェックされているかどうかを確認
    const allChecked = checkedArray.every(Boolean);
    // 全てがチェックされていれば全解除、そうでなければ全選択
    const newCheckedArray = checkedArray.map(() => !allChecked);
    setCheckedArray(newCheckedArray);
    updateUserState(newCheckedArray);
    // setValueArray([]);
  };
  //個別工場選択
  const handleChangeChild = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newCheckedArray = [...checkedArray];
    newCheckedArray[index] = event.target.checked;
    setCheckedArray(newCheckedArray);
    updateUserState(newCheckedArray);
    // setValueArray([]);
  };
  const updateUserState = (newCheckArray: Array<boolean>) => {
    // console.log("checkedArray:", newCheckArray);
    // 全ての子チェックボックスが選択されている場合
    if (newCheckArray.every(Boolean)) {
      updateUserfield([0]);
      //   setValueArray([0]); // 全工場を示す
    } else {
      const selectedValues = fields.slice(1).reduce((acc, field, index) => {
        if (newCheckArray[index]) acc.push(field.id);
        return acc;
      }, [] as number[]);

      // チェック状態がすべてない状態を回避
      if (selectedValues.length === 0) {
        selectedValues.push(fields[1].id); // 最初の子工場をデフォルトで選択
        // const newCheckedArray = [...newCheckArray];
        // newCheckedArray[0] = true;
        // setCheckedArray(newCheckedArray);
      }
      updateUserfield(selectedValues);
      //   setValueArray(selectedValues);
    }
  };

  // userStateの更新関数
  const updateUserfield = (valueArray: Array<Number>) => {
    // console.log("valueArray:", valueArray);
    setUser((prevState: User) => {
      const updatedUser = {
        ...prevState,
        filters: {
          ...prevState.filters,
          field: valueArray,
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });

    // setUser((prevState: User) => {
    //   // 現在のfield配列と新しいvalueArrayが等しいかどうかを確認
    //   const isSameValueArray =
    //     JSON.stringify(prevState.filters.field) ===
    //     JSON.stringify(valueArray);
    //   // 値が異なる場合のみ更新
    //   if (!isSameValueArray) {
    //     // ローカルストレージの更新も同様に条件内で行う
    //     const newUserState = {
    //       ...prevState,
    //       filters: {
    //         ...prevState.filters,
    //         field: valueArray,
    //       },
    //     };
    //     setUserToLocalStorage(newUserState);
    //     return newUserState;
    //   }
    //   // 値が同じ場合は状態を変更せず現在の状態を返す
    //   return prevState;
    // });
  };

  return (
    <div>
      {checkedArray.length > 0 && (
        <>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={displayString}
            renderValue={(displayString) => displayString.join(",")}
            sx={{
              px: 0,
              py: 0,
              mx: 0,
              my: 0,
              boxShadow:
                user?.mode === "lite"
                  ? "0px 0px 3px 1px #898b92"
                  : "0px 0px 3px 1px black",
              color: foreColorCode(user?.mode ?? "dark"),
              height: "38px",
              width: "120px",
              fontSize: "0.8rem",
              "& .MuiSvgIcon-root": {
                color: foreColorCode(user?.mode ?? "dark"),
              },
              "&icon": {
                color: "blue",
              },
              borderRadius: "5px",
              backgroundColor: backGroundColorCode(user?.mode ?? "dark"),

              "& .MuiSelect-select": {
                color: foreColorCode(user?.mode ?? "dark"),
                // backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択エリアの背景色を設定
                // maxheight: "0px",
              },
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  backgroundColor: backGroundColorCode(user?.mode ?? "dark"),

                  // 他のスタイルもここで指定できます。
                },
              },
            }}
          >
            <FormControlLabel
              // label="全工場"
              label={
                // style={{ color: allChecked ? "#0adcc0" : "#7D7C7C" }}
                <MenuItem
                  sx={{
                    ...foreColorChecked(user?.mode ?? "dark", allChecked),
                    fontSize: "0.8rem",
                    "&:hover": {
                      backgroundColor: backGroundColorCode(
                        user?.mode ?? "dark"
                      ), // ホバー時の背景色を変更
                      color: foreColorCodeLite(user?.mode ?? "dark"), // ホバー時の文字色を変更
                    },
                    p: 0,
                    m: 0,
                  }}
                >
                  全分野
                </MenuItem>
              }
              sx={{
                height: "38px",
                mx: "5px",
                px: 0,
                py: 0,
                fontSize: "0.6rem",
                color: foreColorCode(user?.mode ?? "dark"),
                backgroundColor: backGroundColorCode(user?.mode ?? "dark"),
                // 選択された状態のスタイル
                "&.Mui-selected": {
                  backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択時の背景色を変更
                  color: foreColorCodeLite(user?.mode ?? "dark"), // 選択時の文字色を変更
                  // color: "blue",
                },

                // ホバー状態のスタイルも定義できます
                "&:hover": {
                  backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // ホバー時の背景色を変更
                  color: foreColorCodeLite(user?.mode ?? "dark"), // ホバー時の文字色を変更
                  // color: "blue",
                },
                // 選択されていてさらにホバーされた状態のスタイル
                "&.Mui-selected:hover": {
                  backgroundColor: backGroundColorCode(user?.mode ?? "dark"), // 選択 + ホバー時の背景色
                  color: foreColorCodeLite(user?.mode ?? "dark"), // 選択 + ホバー時の文字色
                },
              }}
              control={
                <Checkbox
                  checked={allChecked}
                  indeterminate={indeterminate}
                  onChange={handleChangeAll}
                  value={fields[0].id}
                  sx={{
                    "& .MuiSvgIcon-root": foreColor(user?.mode ?? "dark"),
                    "&.Mui-checked": foreColor(user?.mode ?? "dark"),
                    px: 0,
                    py: 0,
                    height: "38px",
                  }}
                />
              }
            />
            {children}
          </Select>
        </>
      )}
    </div>
  );
});

export default SelectBoxForField;
